// 错误列表
const errorList:{ [key: string]: string } = {
	'::'				: '系统错误',
	':system:'			: '系统错误',
	':user:nologin'		: '暂未登录，请先登录',
	':power:nopower'	: '没有操作权限',
	':domain:origin'	: '无法判断来源',
	':domain:'			: '非法访问',
}
export default class ActiveError extends Error {
	/**
	 * 设置默认错误信息
	 * @param id  错误Id
	 * @param msg 错误信息
	 */
	static set(id: string, msg: string) { errorList[id] = msg; }
	/** 错误Id */
	error: string;
	statusCode?: number;
	/**
	 * 创建错误对象
	 * @param id         错误Id
	 * @param statusCode 状态码
	 */
	constructor(id: string, statusCode?: number);
	/**
	 * 创建错误对象
	 * @param id         错误Id
	 * @param msg        错误信息
	 * @param statusCode 状态码
	 */
	constructor(id: string, msg?: string | number, statusCode?: number);
	constructor(id: string, msg?: string | number, statusCode?: number) {
		if (typeof msg == 'number') { statusCode = msg; }
		if (/#[45]\d{2}$/.test(id)) {
			statusCode = Number(id.substr(-3));
			id = id.substr(0, id.length - 4);
		}
		id = id && String(id) || '::';
		if (msg && typeof msg === 'string') {
			msg = msg;
		} else if (id in errorList) {
			msg = errorList[id];
		} else {
			msg = '';
		}
		super(msg);
		this.error = id;
		this.msg = msg;
		this.statusCode = statusCode;
	}
	/** 获取错误信息 */
	get msg(): string { return this.message; }
	set msg(m: string) { this.message = m; }
	toJSON(): { error: string, msg: string } { return {error: this.error, msg: this.msg}; }
	toString(): string { return this.msg + '(' + this.error +')'; }
	/**
	 * 设置错误所属应用ID
	 * @param id 应用ID
	 */
	setAppId(id: string): void {
		if (this.error.substr(0, 2) !== '$:') { return; }
		this.error = id + this.error.substr(1);
		if (this.msg) { return; }
		if (!(this.error in errorList)) { return; }
		this.msg = errorList[this.error];
	}
}
